import type { ILocalizedText, IRecordTypeOverride, Lang } from '@platform/core/types';

/**
 * Підпис мовою інтерфейсу для перевизначення (ADR-023: сервер зливає підписи за мовами): `{ <мова>: текст }`; той самий текст, що й без
 * перевизначення, чи порожній — undefined (повернути опублікований). Чиста функція.
 */
export function localText(lang: Lang, value: string, published: string): ILocalizedText | undefined {
  const text = value.trim();
  return !text || text === published ? undefined : ({ [lang]: text } as unknown as ILocalizedText);
}

/** Назва, однина чи опис типу запису мовою інтерфейсу; збіг з опублікованим чи порожньо — без перевизначення. Чиста функція. */
export function setTypeText(patch: IRecordTypeOverride, part: 'name' | 'singular' | 'description', lang: Lang, value: string, published: string): IRecordTypeOverride {
  const text = localText(lang, value, published);
  const out = { ...patch };
  const rest = { ...(patch[part] ?? {}) } as Record<string, string | null>;
  delete rest[lang];
  const merged = text ? { ...rest, ...text } : rest;
  if (Object.keys(merged).length) out[part] = merged as unknown as ILocalizedText;
  else delete out[part];
  return out;
}
